import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCopyRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M24 20h-9.6a1 1 0 0 1-.8-.8V6.4q.1-.7.8-.8h6.7q.3 0 .5.2l3 3 .2.5v9.9q-.1.7-.8.8m-9.6 2.4H24c1.8 0 3.2-1.4 3.2-3.2V9.3q0-1.2-1-2.2l-2.9-3q-1-.9-2.2-.9h-6.7a3 3 0 0 0-3.2 3.2v12.8c0 1.8 1.4 3.2 3.2 3.2M8 9.6a3 3 0 0 0-3.2 3.2v12.8c0 1.8 1.4 3.2 3.2 3.2h9.6c1.8 0 3.2-1.4 3.2-3.2v-.8h-2.4v.8q-.1.7-.8.8H8a1 1 0 0 1-.8-.8V12.8q.1-.7.8-.8h.8V9.6z" })
});
export default SvgCopyRegularIcon;
